import { render, staticRenderFns } from "./Crop1Icon.vue?vue&type=template&id=11dac7a4&"
import script from "./Crop1Icon.vue?vue&type=script&lang=js&"
export * from "./Crop1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports